import { AxiosError } from "axios";

import { BaseApiError } from "./BaseApiError";

export interface ServerError extends AxiosError<string> {}

export class ServerError extends BaseApiError {
  constructor(error: AxiosError<string>) {
    super(error);
  }
}
